import type { PreventionControlStatus } from '@terra/shared-contracts-integrations';

export type FindingHasPreventionFilter = 'all' | 'yes' | 'no';

export const DEFAULT_FINDING_HAS_PREVENTION_FILTER: FindingHasPreventionFilter =
  'all';

const REMOVED_PREVENTION_STATUS = 'removed' satisfies PreventionControlStatus;

export const hasVisibleFindingPrevention = (
  preventionStatus?: PreventionControlStatus | null,
): boolean =>
  preventionStatus != null && preventionStatus !== REMOVED_PREVENTION_STATUS;

export const findingHasPreventionFilterItems = [
  { label: 'Has prevention', value: 'yes' },
  { label: 'No prevention', value: 'no' },
] as const;

export const isFindingHasPreventionFilterValue = (
  value: string,
): value is FindingHasPreventionFilter =>
  value === 'all' || value === 'yes' || value === 'no';

export const toHasPreventionQueryParam = (
  filter: FindingHasPreventionFilter,
): boolean | undefined => {
  if (filter === 'yes') {
    return true;
  }

  if (filter === 'no') {
    return false;
  }

  return undefined;
};

export const matchesFindingHasPreventionFilter = ({
  preventionStatus,
  filter,
}: {
  preventionStatus?: PreventionControlStatus | null;
  filter: FindingHasPreventionFilter;
}): boolean => {
  if (filter === 'all') {
    return true;
  }

  const hasPrevention = hasVisibleFindingPrevention(preventionStatus);

  return filter === 'yes' ? hasPrevention : !hasPrevention;
};
